var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 16.9168C15.6115 16.9168 16.9173 15.611 16.9173 14.0002C16.9173 12.3893 15.6115 11.0835 14.0007 11.0835C12.3898 11.0835 11.084 12.3893 11.084 14.0002C11.084 15.611 12.3898 16.9168 14.0007 16.9168Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.584 11.0835V16.9168",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4993 21.0002C10.4993 21.8752 10.2544 22.7035 9.8227 23.4035C9.0177 24.7568 7.53602 25.6668 5.83268 25.6668C4.12935 25.6668 2.64767 24.7568 1.84267 23.4035C1.411 22.7035 1.16602 21.8752 1.16602 21.0002C1.16602 18.4218 3.25435 16.3335 5.83268 16.3335C8.41102 16.3335 10.4993 18.4218 10.4993 21.0002Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57235 20.9761H4.0957",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 19.2729V22.7613",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33398 17.8498V10.4998C2.33398 6.4165 4.66732 4.6665 8.16732 4.6665H19.834C23.334 4.6665 25.6673 6.4165 25.6673 10.4998V17.4998C25.6673 21.5832 23.334 23.3332 19.834 23.3332H9.91732",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default __webpack_public_path__ + "static/media/promotion.df1b5a4511b3e7a4555a0df3a7828e5f.svg";
export { ForwardRef as ReactComponent };